(function () {
  angular.module('ticketco/ticketbuyer/redeem_items')
    .component('redeemItems', {
      templateUrl: 'redeemItemsDialog.html'
    });

}());
